module.exports = __webpack_public_path__ + "img/footer2.82beb1a4.png";